module.exports = "https://images.shiksha.ws/saassets/media/Topband.fa92c3f0.svg";